import { render, staticRenderFns } from "./IdentificationRegistration.vue?vue&type=template&id=f4696282"
import script from "./IdentificationRegistration.vue?vue&type=script&lang=js"
export * from "./IdentificationRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports